var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[(!_vm.$route.path.includes('.html'))?_c('nav-bar'):_vm._e()],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }